module.exports = __webpack_public_path__ + "static/media/us.ef1599b0.svg";